import { NgModule, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../shared/services/AuthGuard';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
//
// Layouts
import { BreadcrumbsComponent } from './shared/components/breadcrumb.component';
import { FullLayoutComponent } from './shared/layouts/full-layout.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SimpleLayoutComponent } from './shared/layouts/simple-layout.component';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/components/nav-dropdown.directive';
import { AsideToggleDirective } from './shared/components/aside.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/components/sidebar.directive';

// Pages
import { LoginPage } from './shared/pages/login.page';
import { AdminHomePage } from "./pages/home.page";
import { CompaniesInstalledPage } from "./pages/Companies/installed.page";
import { CompaniesInterestedPage } from "./pages/Companies/Interested.page";
import { GlossaryPage } from './pages/Settings/glossary.page';
import { InvoicesPage } from './pages/Companies/invoices.page';
import { UpdateScriptsPage } from './pages/Database/scripts.page';
import { TemplatesPage } from './pages/Settings/templates.page';
import { ProductsPage } from './pages/Products/products.page';
import { MarketersPage } from './pages/Marketer/marketers.page';
import { DistributorsPage } from './pages/Marketer/distributors.page';
import { EmailTemplatesPage } from './pages/Settings/emailtemplates.page'; 
import { FirstAidTreatmentsPage } from './pages/Settings/firstaidtreatments.page';
import { LegislativeTypesPage } from './pages/Settings/legislativetypes.page';
import { SubContractorPage } from "./pages/Companies/subcontractor.page";
import { HolidaysPage } from './pages/Settings/holidays.page';

export const ROUTES: any = [
    {
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'dashboard', component: AdminHomePage, data: {
                    title: 'Home'
                },
            },
            {
                path: 'clients/installs', component: CompaniesInstalledPage, data: {
                    title: 'Installs'
                },
            },
            {
                path: 'clients/subcontractors', component: SubContractorPage, data: {
                    title: 'Sub-Contractors'
                },
            },
            {
                path: 'clients/registers', component: CompaniesInterestedPage, data: {
                    title: 'Registers'
                },
            },
            {
                path: 'settings/glossary', component: GlossaryPage, data: {
                    title: 'Glossary'
                },
            },
            {
                path: 'settings/templates', component: TemplatesPage, data: {
                    title: 'Forms Distributing'
                },
            },
            {
                  path: 'settings/emailtemplates', component: EmailTemplatesPage , data: {
                    title: 'Email Templates'
                },
            },
            {
                path: 'settings/legislativetypes', component: LegislativeTypesPage , data: {
                  title: 'Legislative Types'
              },
            },
            {
                path: 'settings/firstaidtreatments', component: FirstAidTreatmentsPage , data: {
                  title: 'First Aid Treatments'
              },
            },
            {
                path: 'settings/holidays', component: HolidaysPage , data: {
                  title: 'Holidays'
              },
            }, 
            {
                path: 'invoices/list', component: InvoicesPage, data: {
                    title: 'Invoices'
                },
            },
            {
                path: 'settings/releases', component: UpdateScriptsPage, data: {
                    title: 'Releases'
                },
            },
            {
                path: 'products/list', component: ProductsPage, data: {
                    title: 'Products'
                },
            },
            {
                path: 'marketers/list', component: MarketersPage, data: {
                    title: 'Marketers'
                },
            },
            {
                path: 'distributors/list', component: DistributorsPage, data: {
                    title: 'Marketers'
                },
            }
        ]
    },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'login', component: LoginPage },
];


@NgModule({
    declarations: [
        FullLayoutComponent,
        SimpleLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        LoginPage,
        //
        CompaniesInstalledPage,
        CompaniesInterestedPage,
        AdminHomePage,
        GlossaryPage,
        InvoicesPage,
        UpdateScriptsPage,
        TemplatesPage,
        EmailTemplatesPage, 
        ProductsPage,
        MarketersPage,
        DistributorsPage,
        FirstAidTreatmentsPage,
        LegislativeTypesPage,
        SubContractorPage,
        HolidaysPage
    ],
    imports: [
        CommonModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        RouterModule.forChild(ROUTES),
    ],
    providers: [{
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    }],
    exports: [
        RouterModule
    ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/admin.module.ts